/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

import { ecosystemSlug } from "Config/Config";
import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import CompanyDetailsCommonHeader from "../../CompanyDetailsCommonHeader/CompanyDetailsCommonHeader";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import SaveCompanySuccessModal from "../Modals/SaveCompanySuccessModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import CompanyForm from "./CompanyForm/CompanyForm";
import CompanyDetailsView from "./CompanyDetailsView/CompanyDetailsView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const CompanyGeneralInfoBody = () => {
  const { t } = useTranslation();
  const params = useParams();
  const history = useHistory();
  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const breadCrumbText = [
    { title: t("Company"), link: "/admin/companies" },
    { title: t("General Info") },
  ];

  const [companyTypeList, setCompanyTypeList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [searchingList, setSearchingList] = useState([]);
  const [interestList, setInterestList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [companyData, setCompanyData] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFileIds, setUploadedFileIds] = useState([]);
  const [logoImage, setLogoImage] = useState("");
  const [logoImageId, setLogoImageId] = useState(null);

  const [isSaving, setIsSaving] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [accreditationCAM, setAccreditationCAM] = useState("");
  const [cliniccharacteristics, setClinicCharacteristics] = useState({
    squaremeters: 0,
    patientspermonth: 0,
    schedule: "",
    authorizations: {
      healthcouncil: {
        number: "",
        expiration: "",
      },
    },
  });

  const [savedCompanyId, setSavedCompanyId] = useState(null);

  const [isCompanyModerator, setIsCompanyModerator] = useState(false);
  const [companyModeratorId, setCompanyModeratorId] = useState(null);

  const [memberStatus, setMemberStatus] = useState({});

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getAllCompanyType = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_COMPANY_TYPE;
      const response = await getData(requestUrl);
      if (response.status) setCompanyTypeList(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllServices = async () => {
    try {
      const response = await getAllCategories(ecosystemSlug, "services");
      if (response) setServiceList(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllSearchingList = async () => {
    try {
      const response = await getAllCategories(ecosystemSlug, "searchings");
      if (response) setSearchingList(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAllInterestList = async () => {
    try {
      const response = await getAllCategories(ecosystemSlug, "interests");
      if (response) setInterestList(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getCompanyDetails = async () => {
    try {
      setIsLoading(true);
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_COMPANY_DETAILS}/${params.id}?modulefrom=backend`;
      const response = await getData(requestUrl);

      console.log("response of company details------>", response);

      if (response.status && response.data) {
        setCompanyData(response.data);
        setLogoImage(
          response.data.logo ? url.SERVER_URL + response.data.logo?.path : ""
        );
        setLogoImageId(response.data.logo?._id || null);

        const files = response.data.uploads.map(({ name, path, _id }) => ({
          name,
          path: url.SERVER_URL + path,
          _id,
        }));
        setUploadedFiles(files);
        setUploadedFileIds(files.map(({ _id }) => ({ _id })));

        // Set accreditationCAM and cliniccharacteristics from API response
        setAccreditationCAM(response.data.accreditationCAM ?? "");
        setClinicCharacteristics(
          response.data.cliniccharacteristics ?? {
            squaremeters: 0,
            patientspermonth: 0,
            schedule: "",
            authorizations: {
              healthcouncil: {
                number: "",
                expiration: "",
              },
            },
          }
        );

        setCompanyModeratorId(response.data.moderator);
        let isModerator = false;
        if (
          response.data.moderator.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN"
        ) {
          isModerator = true;
        } else {
          getMemberDetails();
        }

        setIsCompanyModerator(isModerator);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //function for get details of company member
  const getMemberDetails = async () => {
    try {
      const apiUrl = `${url.API_BASE_URL}${url.API_GET_COMPANY_MEMBER_DETAILS_BY_QUERY}?companyid=${params.id}`;
      const response = await getData(apiUrl);
      // console.log("response in member details", response);
      if (response.status) {
        setMemberStatus({
          id: response.data._id,
          status: response.data.memberstatus,
          modStatus: response.data.moderatorstatus,
          inviteDate: response.data.requestdate,
          joinDate: response.data.joindate,
        });
      }
    } catch (error) {
      console.error("Error fetching member details:", error);
    }
  };

  const logoImageUploadHandler = async (imageData) => {
    setIsImageUploading(true);
    try {
      const requestUrl = `${url.API_BASE_URL}${url.API_SINGLE_FILE_UPLOAD}`;
      const response = await uploadSingleFile(requestUrl, imageData[0]);
      if (response.status) {
        setLogoImage(url.SERVER_URL + response.data.path);
        setLogoImageId(response.data._id);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsImageUploading(false);
    }
  };

  const removeLogoHandler = () => {
    setLogoImage("");
    setLogoImageId(null);
  };

  const docFileUploadHandler = async (docUploadedFiles) => {
    if (docUploadedFiles.length === 0) return;
    setIsFileUploading(true);
    try {
      const requestUrl = `${url.API_BASE_URL}${url.API_MULTIPLE_FILE_UPLOAD}`;
      const response = await uploadMultipleFile(requestUrl, docUploadedFiles);
      if (response.status) {
        const newUploadedFiles = response.data.map(({ name, path, _id }) => ({
          name,
          path: url.SERVER_URL + path,
          _id,
        }));
        setUploadedFiles((prev) => [...prev, ...newUploadedFiles]);

        const newFileIds = response.data.map(({ _id }) => ({ _id }));
        setUploadedFileIds((prev) => [...prev, ...newFileIds]);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsFileUploading(false);
    }
  };

  const removeDocHandler = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    setUploadedFileIds((prev) => prev.filter((_, i) => i !== index));
  };

  const saveCompanyHandler = async (formData) => {
    setIsSaving(true);
    try {
      let finalCompanyData = {
        ...formData,
        logo: logoImageId,
        uploads: uploadedFileIds,
      };
      let response = {};

      if (params.id) {
        const requestUrl = `${url.API_BASE_URL}${url.API_UPDATE_COMPANY}/${params.id}`;
        response = await putData(requestUrl, finalCompanyData);
      } else {
        const requestUrl = `${url.API_BASE_URL}${url.API_ADD_NEW_COMPANY}`;
        response = await postData(requestUrl, finalCompanyData);
      }

      if (response.status) {
        setSavedCompanyId(response.data._id);
        setMessageType("success");
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSaveCompanyModal")
        );
        bootstrapModal.show();
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      console.log(error.message);
    } finally {
      setIsSaving(false);
      setShowAlert(true);
    }
  };

  const afterSaveCompanyModalClose = (actionType = "list") => {
    if (actionType === "list") history.push("/admin/companies");
    else history.push(`/admin/companies/info/${savedCompanyId}`);
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  useEffect(() => {
    if (params.id) {
      getCompanyDetails();
    }
    getAllCompanyType();
    getAllServices();
    getAllSearchingList();
    getAllInterestList();
  }, [params.id]);

  if (
    !(
      userInfo.role.slug === "ADMIN" ||
      userInfo.role.slug === "SUPER_ADMIN" ||
      moduleAccess.includes("MOD_COMPANY")
    )
  ) {
    return <AccessDeniedView />;
  }

  return (
    <div id="content_wrapper">
      <section className="event-details-wrapper bg-white pb-5">
        {params.id && <CompanyDetailsCommonHeader moduleName="info" />}
        <div className="container-fluid px-lg-5 pt-4 pt-md-0">
          <BreadCrumb breadCrumbText={breadCrumbText} bottom={true} />

          {isLoading ? (
            <LoadingSkeleton />
          ) : params.id && !isCompanyModerator ? (
            <CompanyDetailsView
              companyData={companyData}
              memberStatus={memberStatus}
            />
          ) : (
            <CompanyForm
              onSubmit={saveCompanyHandler}
              initialData={companyData}
              isSaving={isSaving}
              companyTypeList={companyTypeList}
              serviceList={serviceList}
              searchingList={searchingList}
              interestList={interestList}
              onUploadLogo={logoImageUploadHandler}
              logoImage={logoImage}
              isImageUploading={isImageUploading}
              onRemoveLogo={removeLogoHandler}
              onUploadDocs={docFileUploadHandler}
              uploadedFiles={uploadedFiles}
              onRemoveDoc={removeDocHandler}
              isFileUploading={isFileUploading}
              params={params}
              accreditationCAM={accreditationCAM}
              setAccreditationCAM={setAccreditationCAM}
              cliniccharacteristics={cliniccharacteristics}
              setClinicCharacteristics={setClinicCharacteristics}
            />
          )}
        </div>
        <SaveCompanySuccessModal
          afterSaveCompanyModalClose={afterSaveCompanyModalClose}
        />
        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </section>
    </div>
  );
};

export default CompanyGeneralInfoBody;
